// extracted by mini-css-extract-plugin
export default {"root":"jKY40R","close":"CiSREQ","closeIcon":"u4VUFL","mobileButtons":"qkb937","clearAllBlock":"GXfamn","clearAll":"mTBkNf","section":"ucMkSd","sectionTypeMadeInUkrainer":"Qwi_cE"};